import React from 'react';
import premium from '../../assets/logo-assine.png';
import { Container } from './styles';

const CardAssinatura: React.FC = () => {
  return (
  <Container>
            <img src={premium} alt="assine" />
            <span className="titulo">VERSÃO PREMIUM</span>
            <span className="subtitulo">APOIE NOSSO APP</span>
            <span className="destk">ADQUIRINDO A VERSÃO PREMIUM VOCÊ TERÁ AS SEGUINTES VANTAGENS:</span>
            <span className="vantagens">
                + SEM BANNERS DA UTILIZAÇÃO DO APP<br/>
                + GERADOR DE PDF PARA IMPRESSÃO<br/>
                + NOTIFICAÇÃO PARA LEMBRAR DE ANOTAR<br/>
                + SEM LIMITE DE CASAIS NA LISTA DE 'ALUNOS'<br/>
                + MELHOR VISUALIZAÇÃO DO MÊS DENTRO DO APP<br/>                
            </span>

            <div className="preco">
                <span className="mini">POR<br/>APENAS</span>
                <span className="valor">11,99</span>
                <span className="mini">POR<br/>TRIMESTRE</span>
            </div>
            <span className="destk2">MENOS QUE UM CAFEZINHO POR MÊS</span>
            <span className="aviso">RENOVAÇÃO AUTOMÁTICA, CANCELE A QUALQUER MOMENTO</span>

            <span className="caminho">PARA ASSINAR, BAIXE E INSTALE O APP,<br/>DENTRO DO APP ACESSE RETIRAR PROPAGANDAS, E ENTÃO FAÇA SUA ASSINATURA.</span>
            <a className="botao" rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.appmob" target="_blank"> BAIXAR NA PLAYSTORE</a>

  </Container>  
  );
}

export default CardAssinatura;